import { useEffect } from 'react';

/* Mirrors the GSAP + Lenis init block in 2.html exactly */
function GsapInit() {
  useEffect(() => {
    let active = true;
    let retryTimer = null;
    let tickerCb = null;
    let lenis = null;
    let ctx = null;

    const tryInit = () => {
      if (!active) return;

      if (!window.gsap || !window.ScrollTrigger || !window.Lenis) {
        retryTimer = setTimeout(tryInit, 100);
        return;
      }

      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;
      const Lenis = window.Lenis;

      gsap.registerPlugin(ScrollTrigger);

      lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        direction: 'vertical',
        gestureDirection: 'vertical',
        smooth: true,
      });

      lenis.on('scroll', ScrollTrigger.update);
      tickerCb = (time) => lenis.raf(time * 1000);
      gsap.ticker.add(tickerCb);
      gsap.ticker.lagSmoothing(0, 0);

      ctx = gsap.context(() => {
        gsap.from('.nav-links a, .logo', {
          y: -20,
          opacity: 0,
          duration: 0.8,
          stagger: 0.1,
          ease: 'power3.out',
        });

        gsap.from('.gs_hero', {
          y: 50,
          opacity: 0,
          duration: 1,
          stagger: 0.2,
          ease: 'power3.out',
          delay: 0.3,
        });

        gsap.to('.hero-content', {
          yPercent: 50,
          opacity: 0,
          scale: 0.9,
          scrollTrigger: {
            trigger: 'header',
            start: 'top top',
            end: 'bottom top',
            scrub: true,
          },
        });

        gsap.utils.toArray('.gs_reveal').forEach((elem) => {
          gsap.fromTo(
            elem,
            { y: 50, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 1,
              ease: 'power3.out',
              scrollTrigger: {
                trigger: elem,
                start: 'top 85%',
                toggleActions: 'play none none reverse',
              },
            }
          );
        });

        gsap.to('.tech-track', {
          xPercent: -25,
          ease: 'none',
          duration: 24,
          repeat: -1,
        });

        if (window.innerWidth > 768) {
          const workSection = document.querySelector('#work');
          const workGrid = document.querySelector('.work-grid');
          if (workSection && workGrid) {
            gsap.to(workGrid, {
              x: () => -(workGrid.scrollWidth - window.innerWidth + window.innerWidth * 0.1) + 'px',
              ease: 'none',
              scrollTrigger: {
                trigger: workSection,
                pin: true,
                scrub: 1,
                start: 'top top',
                end: () => '+=' + workGrid.scrollWidth,
                invalidateOnRefresh: true,
              },
            });
          }
        }
      });

      ScrollTrigger.refresh();
    };

    tryInit();

    return () => {
      active = false;
      if (retryTimer) clearTimeout(retryTimer);
      if (tickerCb && window.gsap) window.gsap.ticker.remove(tickerCb);
      if (ctx) ctx.revert();
      if (lenis) lenis.destroy();
    };
  }, []);

  return null;
}

export default GsapInit;
